/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertId } from './InternalApiAlertId';
import {
    InternalApiAlertIdFromJSON,
    InternalApiAlertIdFromJSONTyped,
    InternalApiAlertIdToJSON,
    InternalApiAlertIdToJSONTyped,
} from './InternalApiAlertId';

/**
 * 
 * @export
 * @interface InternalApiAttachCaseAlertsRequest
 */
export interface InternalApiAttachCaseAlertsRequest {
    /**
     * 
     * @type {Array<InternalApiAlertId>}
     * @memberof InternalApiAttachCaseAlertsRequest
     */
    alerts: Array<InternalApiAlertId>;
}

/**
 * Check if a given object implements the InternalApiAttachCaseAlertsRequest interface.
 */
export function instanceOfInternalApiAttachCaseAlertsRequest(value: object): value is InternalApiAttachCaseAlertsRequest {
    if (!('alerts' in value) || value['alerts'] === undefined) return false;
    return true;
}

export function InternalApiAttachCaseAlertsRequestFromJSON(json: any): InternalApiAttachCaseAlertsRequest {
    return InternalApiAttachCaseAlertsRequestFromJSONTyped(json, false);
}

export function InternalApiAttachCaseAlertsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAttachCaseAlertsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': ((json['alerts'] as Array<any>).map(InternalApiAlertIdFromJSON)),
    };
}

export function InternalApiAttachCaseAlertsRequestToJSON(json: any): InternalApiAttachCaseAlertsRequest {
    return InternalApiAttachCaseAlertsRequestToJSONTyped(json, false);
}

export function InternalApiAttachCaseAlertsRequestToJSONTyped(value?: InternalApiAttachCaseAlertsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': ((value['alerts'] as Array<any>).map(InternalApiAlertIdToJSON)),
    };
}

